import React, { useEffect } from "react";
import { LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { BrandLogo } from "../shared/BrandLogo";
import { applyPwaBranding } from "../../lib/pwaBranding";

export function DriverShell({ children }) {
  const { user, logout } = useAuth();

  useEffect(() => applyPwaBranding({ manifest: "/driver-manifest.json", title: "V Delivery" }), []);

  return (
    <div className="min-h-screen bg-primary" data-testid="driver-shell">
      <header className="flex items-center justify-between border-b border-white/10 bg-primary px-4 py-3.5">
        <div>
          <BrandLogo className="h-5" />
          <p className="mt-1 text-[11px] text-white/60">{user?.username ? `Driver · ${user.username}` : "Driver App"}</p>
        </div>
        <button
          type="button"
          onClick={logout}
          className="flex items-center gap-1.5 rounded-md border border-white/15 px-3 py-1.5 text-xs font-medium text-white/80 transition-colors hover:bg-white/10 hover:text-white"
          data-testid="driver-logout-button"
        >
          <LogOut size={14} strokeWidth={1.5} /> Logout
        </button>
      </header>
      <main className="mx-auto max-w-lg rounded-t-2xl bg-background px-4 py-5" style={{ minHeight: "calc(100vh - 60px)" }} data-testid="driver-main-content">
        {children}
      </main>
    </div>
  );
}
